/* CARAVIUM PLANIFICAR STAGE NAVIGATION FIX V6.9 — CARAVIUM BLUE RESULT SUMMARY */
(function(){
'use strict';
if(!location.pathname.includes('/pages/planificar')) return;

const TRIP_KEY='caravium_ai_trip_v1';
const CHOICES_KEY='caravium_plan_selected_sleep_v2';
const ACTIVE_KEY='caravium_live_trip_active_v1';
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));

function read(k,f){try{return JSON.parse(localStorage.getItem(k)||'')||f}catch{return f}}
function pointFromChoice(o){if(!o)return '';const lat=Number(o.latitud),lon=Number(o.longitud);if(Number.isFinite(lat)&&Number.isFinite(lon))return lat+','+lon;return [o.nombre,o.municipio,o.provincia,'España'].filter(Boolean).join(', ')}
function pointFromStop(s){return [s?.place,s?.province,'España'].filter(Boolean).join(', ')}
function stageOrigin(trip,index,choices){if(index<=0)return String(trip?.origin||'').trim()||pointFromStop(trip?.stops?.[0]);const prevChoice=choices?.['stop-'+(index-1)];return pointFromChoice(prevChoice)||pointFromStop(trip?.stops?.[index-1])}
function stageDestination(trip,index,choices){const choice=choices?.['stop-'+index];return pointFromChoice(choice)||pointFromStop(trip?.stops?.[index])}
function mapsUrl(origin,destination){return 'https://www.google.com/maps/dir/?api=1&travelmode=driving&origin='+encodeURIComponent(origin)+'&destination='+encodeURIComponent(destination)}
function updateNav(){
  const a=$('.cvpw-trip-nav');if(!a)return;
  const trip=read(TRIP_KEY,null);if(!trip?.stops?.length)return;
  const choices=read(CHOICES_KEY,{});
  const index=Math.max(0,Math.min(trip.stops.length-1,Number(localStorage.getItem(ACTIVE_KEY)||0)));
  const origin=stageOrigin(trip,index,choices),destination=stageDestination(trip,index,choices);
  if(!origin||!destination)return;
  a.href=mapsUrl(origin,destination);
  a.dataset.stageOrigin=origin;
  a.dataset.stageDestination=destination;
  a.textContent='Iniciar etapa '+(index+1)+' →';
  a.setAttribute('aria-label','Iniciar etapa '+(index+1)+' en Google Maps');
}

let pageIndex=0,lastSignature='',busy=false;

function addCss(){
  if($('#cv-one-screen-css'))return;
  const s=document.createElement('style');
  s.id='cv-one-screen-css';
  s.textContent=`
    #cv-global-destinations{display:none!important}
    body.cv-one-screen #cpv3-plan{display:block!important}

    /* Resumen terminado: azul CARAVIUM, coherente con el indicador de día activo */
    body:not(.cv-plan-loading) #cvpw-summary-head{
      position:relative!important;overflow:hidden!important;isolation:isolate!important;
      background:#173f68!important;
      color:#fff!important;border:1px solid rgba(255,255,255,.12)!important;
      box-shadow:0 12px 30px rgba(23,63,104,.18)!important;
    }
    body:not(.cv-plan-loading) #cvpw-summary-head h1,
    body:not(.cv-plan-loading) #cvpw-summary-head h2,
    body:not(.cv-plan-loading) #cvpw-summary-head h3{position:relative;z-index:4;color:#fff!important}
    body:not(.cv-plan-loading) #cvpw-summary-head p,
    body:not(.cv-plan-loading) #cvpw-summary-head span{position:relative;z-index:4;color:rgba(255,255,255,.92)!important}
    body:not(.cv-plan-loading) #cvpw-summary-head:before{
      content:'';position:absolute;inset:0;z-index:1;pointer-events:none;opacity:.28;
      background:
        radial-gradient(circle at 82% 18%,rgba(255,255,255,.44) 0 1px,transparent 2px),
        radial-gradient(circle at 92% 64%,rgba(255,215,106,.38) 0 1px,transparent 2px),
        radial-gradient(circle at 72% 78%,rgba(255,255,255,.26) 0 1px,transparent 2px),
        radial-gradient(circle at 61% 24%,rgba(255,215,106,.28) 0 1px,transparent 2px),
        radial-gradient(circle at 95% 28%,rgba(255,255,255,.30) 0 1px,transparent 2px);
    }

    /* Estado pensando: casi negro + brillo dorado animado */
    body.cv-plan-loading #cvpw-summary-head{
      position:relative!important;overflow:hidden!important;isolation:isolate!important;
      background:linear-gradient(135deg,#070b12 0%,#0b1220 42%,#111827 72%,#172033 100%)!important;
      color:#fff!important;border:1px solid rgba(244,197,66,.34)!important;
      box-shadow:0 12px 34px rgba(7,11,18,.34),0 0 30px rgba(244,197,66,.10)!important;
      animation:cvThinkGoldGlow 2.6s ease-in-out infinite;
    }
    body.cv-plan-loading #cvpw-summary-head h1,
    body.cv-plan-loading #cvpw-summary-head h2,
    body.cv-plan-loading #cvpw-summary-head h3{position:relative;z-index:4;color:#fff!important;text-shadow:0 1px 0 rgba(0,0,0,.2)}
    body.cv-plan-loading #cvpw-summary-head p,
    body.cv-plan-loading #cvpw-summary-head span{position:relative;z-index:4;color:rgba(255,255,255,.84)!important}
    body.cv-plan-loading #cvpw-summary-head:before{
      content:'';position:absolute;inset:0;z-index:1;pointer-events:none;opacity:.38;
      background:
        radial-gradient(circle at 78% 24%,rgba(255,215,106,.38) 0 1px,transparent 2px),
        radial-gradient(circle at 91% 66%,rgba(244,197,66,.33) 0 1px,transparent 2px),
        radial-gradient(circle at 68% 74%,rgba(255,215,106,.28) 0 1px,transparent 2px),
        radial-gradient(circle at 86% 39%,rgba(255,255,255,.20) 0 1px,transparent 2px),
        radial-gradient(circle at 57% 22%,rgba(244,197,66,.26) 0 1px,transparent 2px),
        radial-gradient(circle at 95% 20%,rgba(255,215,106,.28) 0 1px,transparent 2px);
      animation:cvStarField 3.2s ease-in-out infinite;
    }

    .cv-think-sparkles{position:absolute;inset:0;z-index:3;pointer-events:none;overflow:hidden;border-radius:inherit}
    .cv-think-sparkle{position:absolute;color:#F4C542;text-shadow:0 0 8px rgba(244,197,66,.85),0 0 18px rgba(255,215,106,.48);line-height:1;opacity:.46;animation:cvGoldSparkle 2.4s ease-in-out infinite}
    body:not(.cv-plan-loading) .cv-think-sparkle{color:#fff;text-shadow:0 0 8px rgba(255,255,255,.45);opacity:.42;animation-duration:3.1s}
    .cv-think-sparkle:nth-child(1){right:3.5%;top:16%;font-size:24px;animation-delay:.0s}
    .cv-think-sparkle:nth-child(2){right:8%;top:55%;font-size:16px;animation-delay:.35s}
    .cv-think-sparkle:nth-child(3){right:14%;top:28%;font-size:13px;animation-delay:.75s}
    .cv-think-sparkle:nth-child(4){right:20%;top:69%;font-size:20px;animation-delay:1.15s}
    .cv-think-sparkle:nth-child(5){right:27%;top:18%;font-size:11px;animation-delay:.55s}
    .cv-think-sparkle:nth-child(6){right:33%;top:76%;font-size:14px;animation-delay:1.45s}
    .cv-think-sparkle:nth-child(7){left:4%;top:20%;font-size:12px;animation-delay:1.05s}
    .cv-think-sparkle:nth-child(8){left:9%;bottom:16%;font-size:17px;animation-delay:.2s}
    .cv-think-sparkle:nth-child(9){left:27%;top:12%;font-size:10px;animation-delay:1.7s}
    .cv-think-sparkle:nth-child(10){left:38%;bottom:12%;font-size:13px;animation-delay:.9s}
    .cv-think-sparkle:nth-child(11){right:42%;top:19%;font-size:9px;animation-delay:1.25s}
    .cv-think-sparkle:nth-child(12){right:45%;bottom:15%;font-size:11px;animation-delay:.45s}
    @keyframes cvThinkGoldGlow{0%,100%{box-shadow:0 12px 34px rgba(7,11,18,.34),0 0 22px rgba(244,197,66,.07)}50%{box-shadow:0 14px 40px rgba(7,11,18,.42),0 0 34px rgba(244,197,66,.16)}}
    @keyframes cvGoldSparkle{0%,100%{opacity:.26;transform:scale(.78) rotate(0deg)}48%{opacity:1;transform:scale(1.26) rotate(18deg)}68%{opacity:.66;transform:scale(.98) rotate(28deg)}}
    @keyframes cvStarField{0%,100%{opacity:.26}50%{opacity:.56}}

    #cv-one-screen-nav{margin:14px 0 6px;padding:14px 16px;border:1px solid #dbe6eb;border-radius:18px;background:#fff;box-shadow:0 8px 24px rgba(18,59,93,.07)}
    #cv-one-screen-nav .cvos-meta{display:flex;justify-content:space-between;gap:10px;align-items:center;font-weight:900;color:#123b5d;margin-bottom:10px}
    #cv-one-screen-nav .cvos-stepper{position:relative;display:flex;align-items:flex-start;justify-content:space-between;gap:6px;margin:2px 0 12px;padding:0 2px}
    #cv-one-screen-nav .cvos-stepper:before{content:'';position:absolute;left:22px;right:22px;top:18px;height:4px;background:#dce8ed;border-radius:99px;z-index:0}
    #cv-one-screen-nav .cvos-stepper-progress{position:absolute;left:22px;top:18px;height:4px;background:#14b8a6;border-radius:99px;z-index:1;transition:width .2s ease}
    #cv-one-screen-nav .cvos-step{position:relative;z-index:2;display:flex;flex-direction:column;align-items:center;min-width:44px;flex:1;color:#8093a3;font-size:12px;font-weight:800;text-align:center}
    #cv-one-screen-nav .cvos-dot{width:36px;height:36px;border-radius:50%;display:grid;place-items:center;background:#edf3f6;border:2px solid #d7e3e8;color:#607487;font-size:14px;font-weight:900;box-shadow:0 0 0 4px #fff}
    #cv-one-screen-nav .cvos-step.done .cvos-dot{background:#14b8a6;border-color:#14b8a6;color:#fff}
    #cv-one-screen-nav .cvos-step.active .cvos-dot{background:#173f68;border-color:#173f68;color:#fff;transform:scale(1.06)}
    #cv-one-screen-nav .cvos-step.done,#cv-one-screen-nav .cvos-step.active{color:#123b5d}
    #cv-one-screen-nav .cvos-day-label{margin-top:5px;white-space:nowrap}
    #cv-one-screen-nav .cvos-help{min-height:20px;margin:0 0 10px;color:#607487;font-size:14px;font-weight:700}
    #cv-one-screen-nav .cvos-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px}
    #cv-one-screen-nav button{min-height:50px;border:0;border-radius:13px;padding:11px 16px;font:inherit;font-weight:900;cursor:pointer}
    #cv-one-screen-nav .cvos-prev{background:#eaf3f7;color:#123b5d}
    #cv-one-screen-nav .cvos-next{background:#14b8a6;color:#fff}
    #cv-one-screen-nav button[disabled]{opacity:.46;cursor:not-allowed}
    body.cv-plan-loading footer{display:none!important}
    body.cv-one-screen #cpv3-plan>.cvpw-pro-results{display:none!important}
    .cvos-pro-inline{margin:4px 0 2px;padding:15px;border:1px solid rgba(240,196,81,.62);border-radius:17px;background:linear-gradient(145deg,#fffdf7,#fff8df)}
    .cvos-pro-kicker{font-size:11px;font-weight:950;letter-spacing:.06em;color:#9b7100;margin-bottom:4px}
    .cvos-pro-inline>h4{margin:0 0 12px;color:#123b5d;font-size:18px}
    .cvos-pro-group{display:grid;gap:9px}
    .cvos-pro-group+.cvos-pro-group{margin-top:13px;padding-top:12px;border-top:1px solid #eadb9e}
    .cvos-pro-group-title{font-size:12px;font-weight:950;text-transform:uppercase;color:#8b6700}
    .cvos-pro-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px}
    .cvos-pro-grid .cvpw-pro-card{margin:0!important;padding:13px!important;border-radius:14px!important;box-shadow:none!important}
    .cvos-pro-grid .cvpw-pro-card h3{font-size:17px!important}
    .cvos-pro-grid .cvpw-pro-card p{font-size:13px!important;line-height:1.42!important}
    .cvos-pro-grid .cvpw-pro-link{min-height:38px!important;padding:8px 11px!important;font-size:12px!important}

    @media(max-width:700px){
      .cvos-pro-grid{grid-template-columns:1fr}

      #cvpw-summary-head{padding:21px 20px!important;border-radius:20px!important}
      #cvpw-summary-head h1,#cvpw-summary-head h2{font-size:28px!important;line-height:1.14!important;letter-spacing:-.02em!important}
      #cvpw-summary-head h3{font-size:23px!important;line-height:1.2!important}
      #cvpw-summary-head p,#cvpw-summary-head span{font-size:16.5px!important;line-height:1.5!important}
      .cvpw-ai-loading{font-size:17px!important;line-height:1.5!important}
      .cv-think-sparkle:nth-child(n+9){display:none}
      #cpv3-plan .cvpw-ai-day{min-height:0!important;padding:20px!important;border-radius:20px!important}
      #cpv3-plan .cvpw-ai-day h2{font-size:28px!important;line-height:1.15!important}
      #cpv3-plan .cvpw-ai-day h3{font-size:25px!important;line-height:1.2!important}
      #cpv3-plan .cvpw-ai-day p,#cpv3-plan .cvpw-ai-day li,#cpv3-plan .cvpw-ai-day label,#cpv3-plan .cvpw-ai-day .cvpw-ai-range,#cpv3-plan .cvpw-ai-day .cvpw-ai-why{font-size:16.5px!important;line-height:1.52!important}
      #cpv3-plan .cvpw-ai-day button,#cpv3-plan .cvpw-ai-day a[role='button'],#cpv3-plan .cvpw-ai-day .cvpw-trip-nav{min-height:54px!important;font-size:17px!important;line-height:1.2!important;padding:13px 16px!important;border-radius:14px!important}
      #cpv3-plan .cvpw-sleep-options>*{padding:16px!important;border-radius:16px!important}
      #cv-one-screen-nav{position:sticky;bottom:8px;z-index:30;margin:10px 0;background:rgba(255,255,255,.98);backdrop-filter:blur(8px);padding:14px;border-radius:18px}
      #cv-one-screen-nav .cvos-meta{font-size:15px;line-height:1.3;margin-bottom:12px}
      #cv-one-screen-nav .cvos-actions{grid-template-columns:1fr 1.25fr;gap:10px}
      #cv-one-screen-nav button{min-height:54px;font-size:17px;padding:12px 13px;border-radius:14px}
      #cv-one-screen-nav .cvos-help{font-size:15px;line-height:1.4}
      #cv-one-screen-nav .cvos-stepper{gap:2px;margin-bottom:14px}
      #cv-one-screen-nav .cvos-stepper:before{left:20px;right:20px;top:18px}
      #cv-one-screen-nav .cvos-stepper-progress{left:20px;top:18px}
      #cv-one-screen-nav .cvos-dot{width:36px;height:36px;font-size:14px;box-shadow:0 0 0 3px #fff}
      #cv-one-screen-nav .cvos-day-label{font-size:12px;margin-top:6px}
    }
    @media(prefers-reduced-motion:reduce){body.cv-plan-loading #cvpw-summary-head,.cv-think-sparkle,body.cv-plan-loading #cvpw-summary-head:before{animation:none!important}}
  `;
  document.head.appendChild(s);
}

function ensureThinkSparkles(){
  const head=$('#cvpw-summary-head');if(!head)return;
  let layer=$('.cv-think-sparkles',head);
  if(!layer){
    layer=document.createElement('div');layer.className='cv-think-sparkles';layer.setAttribute('aria-hidden','true');
    const glyphs=['✦','✧','✦','✧','✦','✧','✦','✧','✦','✧','✦','✧'];
    glyphs.forEach(g=>{const sp=document.createElement('span');sp.className='cv-think-sparkle';sp.textContent=g;layer.appendChild(sp)});
    head.appendChild(layer);
  }
}
function resultCards(){const plan=$('#cpv3-plan');return plan?$$('.cvpw-ai-day',plan):[]}
function signature(cards){return cards.map((c,i)=>c.getAttribute('data-stop-index')||c.id||String(i)).join('|')+'|'+cards.length}
function isLoading(){const load=$('.cvpw-ai-loading');const title=$('#cvpw-summary-head h2');const active=!!load||!!(title&&/diseñando tu viaje|copilot trabajando/i.test(title.textContent||''));document.body.classList.toggle('cv-plan-loading',active);ensureThinkSparkles();if(active){document.body.classList.remove('cv-one-screen');$('#cv-one-screen-nav')?.remove()}return active}
function forceVisibility(cards,index){cards.forEach((card,i)=>{const active=i===index;card.classList.toggle('cvos-active',active);card.setAttribute('aria-hidden',active?'false':'true');card.style.setProperty('display',active?'grid':'none','important')})}
function cvosNorm(v){
  return String(v||'')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g,' ')
    .trim();
}
function cvosEsc(v){
  return String(v??'')
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;')
    .replace(/'/g,'&#039;');
}
function cvosSafeUrl(v){
  try{
    const u=new URL(String(v||''),location.origin);
    return /^https?:$/.test(u.protocol)?u.href:'';
  }catch{return''}
}
function cvosStageParts(card,stop){
  if(stop){
    return {
      place:cvosNorm(stop.place),
      province:cvosNorm(stop.province)
    };
  }
  const raw=(card?.querySelector('h3')?.textContent||'').trim();
  const parts=raw.split('·').map(cvosNorm).filter(Boolean);
  return {place:parts[0]||'',province:parts[1]||''};
}
function cvosProMatches(x,stage){
  const near=cvosNorm(x?.near_stop);
  const municipality=cvosNorm(x?.municipality);
  const province=cvosNorm(x?.province);
  const hay=(near+' '+municipality+' '+province).trim();

  if(stage.place && hay.includes(stage.place))return true;
  if(stage.province && hay.includes(stage.province))return true;
  return false;
}
function syncProForCard(card){
  if(!card)return;

  const current=$('.cvos-pro-inline',card);
  if(card.querySelector('.cvpw-stage-pro')){
    current?.remove();
    return;
  }

  const idx=Number(card.getAttribute('data-stop-index'));
  const trip=read(TRIP_KEY,null);
  const stop=Number.isFinite(idx)?trip?.stops?.[idx]:null;
  const stage=cvosStageParts(card,stop);

  // 1) Prefer structured Pro data saved with the trip.
  if(trip?.pro_search_used && trip?.pro_discovery){
    let groups=Array.isArray(trip.pro_discovery.groups)
      ?trip.pro_discovery.groups
      :[];

    if(!groups.length && Array.isArray(trip.pro_discovery.results)){
      groups=[{
        label:trip.pro_discovery.intent||'Experiencias Pro',
        request:trip.pro_discovery.intent||'',
        results:trip.pro_discovery.results
      }];
    }

    const matched=groups
      .map(g=>({
        label:String(g?.label||g?.request||'Experiencias Pro').trim(),
        results:(Array.isArray(g?.results)?g.results:[])
          .filter(x=>cvosProMatches(x,stage))
      }))
      .filter(g=>g.results.length);

    const signature=matched
      .map(g=>g.label+':'+g.results.map(x=>x.name||'').join('|'))
      .join('||');

    if(signature){
      if(current?.dataset.signature===signature)return;
      current?.remove();

      const box=document.createElement('section');
      box.className='cvos-pro-inline';
      box.dataset.signature=signature;

      let html='<div class="cvos-pro-kicker">✦ COPILOT PRO · EXPERIENCIAS EN ESTA ETAPA</div><h4>También has pedido esto para tu viaje</h4>';

      matched.forEach(g=>{
        html+='<div class="cvos-pro-group"><div class="cvos-pro-group-title">'+cvosEsc(g.label)+'</div><div class="cvos-pro-grid">';

        g.results.forEach(x=>{
          const href=cvosSafeUrl(x.url);
          const where=[x.municipality,x.province].filter(Boolean).join(' · ');

          html+='<article class="cvpw-pro-card">';
          html+='<div class="cvpw-pro-type">'+cvosEsc(x.type||'Experiencia encontrada')+'</div>';
          html+='<h3>'+cvosEsc(x.name||'Experiencia')+'</h3>';
          if(where)html+='<div class="cvpw-pro-place">'+cvosEsc(where)+'</div>';
          if(x.near_stop)html+='<div class="cvpw-pro-near">Encaja cerca de: '+cvosEsc(x.near_stop)+'</div>';
          if(x.why)html+='<p>'+cvosEsc(x.why)+'</p>';
          if(href)html+='<a class="cvpw-pro-link" href="'+cvosEsc(href)+'" target="_blank" rel="noopener noreferrer">Ver sitio ↗</a>';
          html+='</article>';
        });

        html+='</div></div>';
      });

      box.innerHTML=html;

      const sleepBlock=Array.from(card.children).find(el=>
        /d[oó]nde dormir/i.test(el.textContent||'')
      );

      if(sleepBlock)card.insertBefore(box,sleepBlock);
      else card.appendChild(box);
      return;
    }
  }

  // 2) Compatibility with already-generated routes:
  // clone the Pro cards that are still present in the summary DOM.
  const source=$('#cpv3-plan>.cvpw-pro-results');
  if(source){
    const domGroups=[];

    $$('.cvpw-pro-group',source).forEach(group=>{
      const label=(group.querySelector('.cvpw-pro-group-head h3')?.textContent||'Experiencias Pro').trim();
      const cards=$$('.cvpw-pro-card',group).filter(x=>{
        const near=x.querySelector('.cvpw-pro-near')?.textContent||'';
        const place=x.querySelector('.cvpw-pro-place')?.textContent||'';
        const hay=cvosNorm(near+' '+place);
        return (stage.place&&hay.includes(stage.place))||(stage.province&&hay.includes(stage.province));
      });
      if(cards.length)domGroups.push({label,cards});
    });

    const signature=domGroups
      .map(g=>g.label+':'+g.cards.map(x=>x.querySelector('h3')?.textContent||'').join('|'))
      .join('||');

    if(signature){
      if(current?.dataset.signature===signature)return;
      current?.remove();

      const box=document.createElement('section');
      box.className='cvos-pro-inline';
      box.dataset.signature=signature;
      box.innerHTML='<div class="cvos-pro-kicker">✦ COPILOT PRO · EXPERIENCIAS EN ESTA ETAPA</div><h4>También has pedido esto para tu viaje</h4>';

      domGroups.forEach(g=>{
        const wrap=document.createElement('div');
        wrap.className='cvos-pro-group';

        const title=document.createElement('div');
        title.className='cvos-pro-group-title';
        title.textContent=g.label;
        wrap.appendChild(title);

        const grid=document.createElement('div');
        grid.className='cvos-pro-grid';
        g.cards.forEach(x=>grid.appendChild(x.cloneNode(true)));
        wrap.appendChild(grid);
        box.appendChild(wrap);
      });

      const sleepBlock=Array.from(card.children).find(el=>
        /d[oó]nde dormir/i.test(el.textContent||'')
      );

      if(sleepBlock)card.insertBefore(box,sleepBlock);
      else card.appendChild(box);
      return;
    }
  }

  current?.remove();
}
function dayRangeFromCard(card,fallback){const txt=(card?.querySelector('.cvpw-ai-range')?.textContent||card?.textContent||'').trim();const head=(txt.match(/D[ií]as?\s*(\d+)(?:\s*[–—-]\s*(\d+))?/i)||[]);if(head.length){const start=Math.max(1,Number(head[1])||fallback);const end=Math.max(start,Number(head[2])||start);return {start,end}}return {start:fallback,end:fallback}}
function selectedTripDays(){const direct=['#cpv3-days','#cvpw-days','#cpv3-dias','select[name="days"]','select[name="dias"]'];for(const sel of direct){const el=$(sel);const n=Number(el?.value);if(Number.isFinite(n)&&n>0&&n<100)return n}const roots=[$('#cpv3-wizard'),$('#cpv3-plan')?.previousElementSibling,$('main'),document].filter(Boolean);for(const root of roots){for(const el of $$('select',root)){const hint=[el.id,el.name,el.getAttribute('aria-label'),el.closest('label')?.textContent,el.parentElement?.querySelector('label')?.textContent].filter(Boolean).join(' ').toLowerCase();if(!/d[ií]as|days/.test(hint))continue;const n=Number(el.value);if(Number.isFinite(n)&&n>0&&n<100)return n}}return null}
function totalTripDays(cards){const selected=selectedTripDays();if(selected)return selected;const trip=read(TRIP_KEY,{})||{};const candidates=[trip?.request?.days,trip?.input?.days,trip.days,trip.total_days,trip.duration_days,trip?.meta?.days,trip.duration];for(const v of candidates){const n=Number(v);if(Number.isFinite(n)&&n>0&&n<100)return n}let maxDay=1;cards.forEach((c,i)=>{maxDay=Math.max(maxDay,dayRangeFromCard(c,i+1).end)});return maxDay}
function sleepState(card){if(!card)return {hasOptions:false,selected:true};const idx=card.getAttribute('data-stop-index');const scope=card.querySelector('.cvpw-sleep-options')||card;const buttons=$$('button',scope).filter(b=>/seleccionar|seleccionado/i.test((b.textContent||'').trim()));const hasOptions=buttons.length>0;if(!hasOptions)return {hasOptions:false,selected:true};const choices=read(CHOICES_KEY,{});const stored=idx!=null&&!!choices['stop-'+idx];const visual=buttons.some(b=>/seleccionado/i.test((b.textContent||'').trim()))||!!scope.querySelector('.is-selected,.selected,[aria-pressed="true"]');return {hasOptions:true,selected:stored||visual}}
function ensureNav(card){let nav=$('#cv-one-screen-nav');if(!nav){nav=document.createElement('div');nav.id='cv-one-screen-nav';nav.innerHTML='<div class="cvos-meta"><span class="cvos-label"></span><span class="cvos-count"></span></div><div class="cvos-stepper"><div class="cvos-stepper-progress"></div></div><div class="cvos-help"></div><div class="cvos-actions"><button type="button" class="cvos-prev">← Inicio</button><button type="button" class="cvos-next">Ir a etapa 2 →</button></div>';$('.cvos-prev',nav).addEventListener('click',()=>showPage(pageIndex-1,true));$('.cvos-next',nav).addEventListener('click',()=>showPage(pageIndex+1,true))}if(card&&card.parentNode&&nav.previousElementSibling!==card)card.insertAdjacentElement('afterend',nav);return nav}
function renderStepper(nav,total,start,end){const stepper=$('.cvos-stepper',nav);if(!stepper)return;const progress=$('.cvos-stepper-progress',stepper);$$('.cvos-step',stepper).forEach(n=>n.remove());for(let day=1;day<=total;day++){const step=document.createElement('div');const cls=day<start?' done':(day>=start&&day<=end?' active':'');step.className='cvos-step'+cls;step.innerHTML='<div class="cvos-dot">'+day+'</div><div class="cvos-day-label">Día '+day+'</div>';stepper.appendChild(step)}const pct=total<=1?0:((Math.min(end,total)-1)/(total-1))*100;if(progress){const inset=44;progress.style.width='calc('+pct+'% - '+(pct===0?0:inset*pct/100)+'px)'}}
function showPage(i,scroll){const cards=resultCards();if(!cards.length)return;pageIndex=Math.max(0,Math.min(cards.length-1,i));forceVisibility(cards,pageIndex);document.body.classList.add('cv-one-screen');const card=cards[pageIndex];syncProForCard(card);const nav=ensureNav(card);const last=pageIndex===cards.length-1;const state=sleepState(card);const needsChoice=!last&&state.hasOptions&&!state.selected;const totalDays=totalTripDays(cards);let range=dayRangeFromCard(card,pageIndex+1);range.start=Math.min(Math.max(1,range.start),totalDays);range.end=Math.min(Math.max(range.start,range.end),totalDays);if(last)range.end=totalDays;const label=range.start===range.end?'Día '+range.start:'Días '+range.start+'–'+range.end;$('.cvos-label',nav).textContent=label+' · Etapa '+(pageIndex+1)+' de '+cards.length;$('.cvos-count',nav).textContent=label+' de '+totalDays;renderStepper(nav,totalDays,range.start,range.end);const prev=$('.cvos-prev',nav);prev.disabled=pageIndex===0;prev.textContent=pageIndex===0?'← Inicio':'← Volver a etapa '+pageIndex;const next=$('.cvos-next',nav);next.disabled=last||needsChoice;if(last)next.textContent='Última etapa';else if(needsChoice)next.textContent='Selecciona dónde dormir';else next.textContent='Ir a etapa '+(pageIndex+2)+' →';$('.cvos-help',nav).textContent=needsChoice?'Elige una opción de pernocta para continuar.':'';const finalNote=$('#cpv3-plan .cvpw-final-note');if(finalNote)finalNote.style.setProperty('display',last?'block':'none','important');const tripEnd=$('#cvpw-trip-end');if(tripEnd)tripEnd.style.setProperty('display',last?'block':'none','important');updateNav();if(scroll){const top=Math.max(0,card.getBoundingClientRect().top+window.scrollY-150);window.scrollTo({top,behavior:'smooth'})}}
function apply(){if(busy)return;busy=true;try{addCss();if(isLoading())return;const cards=resultCards();if(!cards.length){document.body.classList.remove('cv-one-screen');$('#cv-one-screen-nav')?.remove();return}const sig=signature(cards);if(sig!==lastSignature){lastSignature=sig;pageIndex=0}showPage(pageIndex,false)}finally{busy=false}}
function boot(){addCss();apply();const plan=$('#cpv3-plan')||document.body;const obs=new MutationObserver(()=>{clearTimeout(window.__cvOneScreenTimer);window.__cvOneScreenTimer=setTimeout(apply,140)});obs.observe(plan,{childList:true,subtree:true});document.addEventListener('click',ev=>{if(ev.target.closest?.('.cvpw-select-sleep,.cvpw-sleep-option button,.cvpw-ai-day button')){setTimeout(apply,80);setTimeout(apply,260)}if(ev.target.closest?.('#cvpw-prev-stage,#cvpw-next-stage,#cvpw-restart-trip,#cvpw-start-trip'))setTimeout(updateNav,0)},true)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();